import initVueApp from "@/core.js";
const component = require(`./../views/LandingSS24.vue`).default;
initVueApp(component);
